// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input::-moz-placeholder {
  color: rgba(0,0,0,.87) !important;
}
input,
input:focus,
input::placeholder {
  color: rgba(0,0,0,.87) !important;
}
`, "",{"version":3,"sources":["webpack://./src/custom.css"],"names":[],"mappings":"AAAA;EAGE,iCAAiC;AACnC;AAJA;;;EAGE,iCAAiC;AACnC","sourcesContent":["input,\ninput:focus,\ninput::placeholder {\n  color: rgba(0,0,0,.87) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
